import { Box, Divider, Flex, HStack, Text } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { AppRoute } from '../../../routes';

interface SidebarLinksProps {
	routes: AppRoute[];
}

interface RouteSection {
	title?: string;
	routes: AppRoute[];
}

// Agrupa as rotas por `section`, preservando a ordem de declaração. Rotas sem
// `section` formam o bloco principal (sem cabeçalho); as demais são agrupadas
// sob um rótulo (ex.: "Admin").
function groupBySection(routes: AppRoute[]): RouteSection[] {
	const sections: RouteSection[] = [];
	for (const route of routes) {
		const title = route.section;
		const last = sections[sections.length - 1];
		if (last && last.title === title) {
			last.routes.push(route);
		} else {
			sections.push({ title, routes: [route] });
		}
	}
	return sections;
}

export function SidebarLinks(props: SidebarLinksProps) {
	const { routes } = props;
	const location = useLocation();

	const activeRoute = (routeName: string) => {
		return location.pathname.includes(routeName);
	};

	const sections = groupBySection(routes.filter(r => !r.hidden));

	return (
		<Box>
			{sections.map((section, sectionIndex) => (
				<Box key={section.title ?? `section-${sectionIndex}`} mt={section.title ? '20px' : '0'}>
					{section.title && (
						<>
							<Divider borderColor='whiteAlpha.200' mb='12px' />
							<Text
								color='#5E7CA8'
								fontSize='xs'
								fontWeight='700'
								textTransform='uppercase'
								letterSpacing='0.08em'
								px='14px'
								mb='8px'>
								{section.title}
							</Text>
						</>
					)}
					{section.routes.map((route, index) => {
						const active = activeRoute(route.path.toLowerCase());
						return (
							<NavLink key={index} to={route.layout + route.path}>
								<HStack
									spacing='14px'
									py='11px'
									px='14px'
									mb='6px'
									borderRadius='14px'
									bg={active ? 'brand.500' : 'transparent'}
									transition='.2s all ease'
									_hover={{ bg: active ? 'brand.500' : 'whiteAlpha.100' }}>
									<Flex
										align='center'
										justify='center'
										color={active ? 'white' : '#9FC0F0'}
										fontSize='20px'>
										{route.icon}
									</Flex>
									<Text
										color={active ? 'white' : '#9FC0F0'}
										fontWeight={active ? '700' : '500'}
										fontSize='sm'>
										{route.name}
									</Text>
								</HStack>
							</NavLink>
						);
					})}
				</Box>
			))}
		</Box>
	);
}

export default SidebarLinks;
